import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformRESTFloatToSDKFloat } from '@wix/sdk-runtime/transformations/float';
import { transformRESTBytesToSDKBytes } from '@wix/sdk-runtime/transformations/bytes';
import { transformSDKTimestampToRESTTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixpressNpmCommunitiesPlatformizedBlogV3PostServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    _: [
      {
        srcPath: '/_api/communities-blog-node-api/v3/posts',
        destPath: '/v3/posts',
      },
    ],
    'apps._base_domain_': [
      {
        srcPath: '/_api/communities-blog-node-api/v3/posts',
        destPath: '/v3/posts',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/communities-blog-node-api/v3/posts',
        destPath: '/v3/posts',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/v3/posts',
        destPath: '/v3/posts',
      },
      {
        srcPath: '/blog/v3/posts',
        destPath: '/v3/posts',
      },
      {
        srcPath: '/_api/v3/posts',
        destPath: '/v3/posts',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/communities-blog-node-api/v3/posts',
        destPath: '/v3/posts',
      },
      {
        srcPath: '/_api/post-service-api-proxy/v3/bulk/posts',
        destPath: '/v3/bulk/posts',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/communities-blog-node-api/v3/posts',
        destPath: '/v3/posts',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/communities-blog-node-api/v3/posts',
        destPath: '/v3/posts',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/communities-blog-node-api/v3/posts',
        destPath: '/v3/posts',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/communities-blog-node-api/v3/posts',
        destPath: '/v3/posts',
      },
    ],
    'editor.wixapps.net': [
      {
        srcPath: '/_api/communities-blog-node-api/v3/posts',
        destPath: '/v3/posts',
      },
    ],
    'dev._base_domain_': [
      {
        srcPath: '/_api/communities-blog-node-api/v3/posts',
        destPath: '/v3/posts',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

function resolveComWixpressNpmCommunitiesPlatformizedBlogBlogStatsServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'api._api_base_domain_': [
      {
        srcPath: '/communities-blog-node-api',
        destPath: '',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/communities-blog-node-api',
        destPath: '',
      },
      {
        srcPath: '/_api/communities-blog-node-api/v2/stats',
        destPath: '/v2/stats',
      },
    ],
    'apps._base_domain_': [
      {
        srcPath: '/_api/communities-blog-node-api',
        destPath: '',
      },
      {
        srcPath: '/_api/communities-blog-node-api/v2/stats',
        destPath: '/v2/stats',
      },
    ],
    _: [
      {
        srcPath: '/_api/communities-blog-node-api',
        destPath: '',
      },
      {
        srcPath: '/_api/communities-blog-node-api/_api/blogs/this',
        destPath: '/_api/blogs/this',
      },
      {
        srcPath: '/_api/communities-blog-node-api/_api/categories',
        destPath: '/_api/categories',
      },
      {
        srcPath: '/_api/communities-blog-node-api/_api/site-properties',
        destPath: '/_api/site-properties',
      },
      {
        srcPath: '/_api/communities-blog-node-api/_api/posts/content',
        destPath: '/_api/posts/content',
      },
      {
        srcPath: '/_api/communities-blog-node-api/v2/stats',
        destPath: '/v2/stats',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/communities-blog-node-api',
        destPath: '',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/communities-blog-node-api',
        destPath: '',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/communities-blog-node-api',
        destPath: '',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/communities-blog-node-api',
        destPath: '',
      },
    ],
    '*.pub.wix-code.com': [
      {
        srcPath: '/_api/communities-blog-node-api',
        destPath: '',
      },
    ],
    'bo._base_domain_': [
      {
        srcPath: '/_api/communities-blog-node-api',
        destPath: '',
      },
      {
        srcPath: '/_api/communities-blog-node-api',
        destPath: '',
      },
    ],
    'wixbo.ai': [
      {
        srcPath: '/_api/communities-blog-node-api',
        destPath: '',
      },
      {
        srcPath: '/_api/communities-blog-node-api',
        destPath: '',
      },
    ],
    'wix-bo.com': [
      {
        srcPath: '/_api/communities-blog-node-api',
        destPath: '',
      },
      {
        srcPath: '/_api/communities-blog-node-api',
        destPath: '',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/communities-blog-node-api',
        destPath: '',
      },
    ],
    'social-blog._base_domain_': [
      {
        srcPath: '/_api/communities-blog-node-api',
        destPath: '',
      },
    ],
    'editor.wixapps.net': [
      {
        srcPath: '/_api/communities-blog-node-api',
        destPath: '',
      },
    ],
    'dev._base_domain_': [
      {
        srcPath: '/_api/communities-blog-node-api',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/blog/v2',
        destPath: '/v2',
      },
      {
        srcPath: '/blog/v3',
        destPath: '/v3',
      },
      {
        srcPath: '/v2/stats',
        destPath: '/v2/stats',
      },
      {
        srcPath: '/blog/v2/stats',
        destPath: '/v2/stats',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_blog_posts';

/**
 * Retrieves the number of published posts per month within a specified time range.
 *
 * The time range is set using the `rangeStart` and `months` properties.
 * The time range always starts on the 1st day of the month set in `rangeStart` and
 * includes the number of `months` following `rangeStart`.
 * For example, if `rangeStart` is set to `'2022-03-13'` and `months` is set to `4`,
 * the time range will be from `'2022-03-01'` until `'2022-06-30'`. The time range always ends on the last day of the month.
 * > Note: If there are no published posts in a month within the time range, that month is not included in the response. For example, let's say a blog has `0` posts dated in February 2022. If `rangeStart` is set to `'2022-01-01'` and `months` is set to `3`, the response includes `postCount` values for January and March, but not February.
 */
export function queryPostCountStats(
  payload: object
): RequestOptionsFactory<any> {
  function __queryPostCountStats({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [{ path: 'rangeStart' }, { path: 'rangeEnd' }],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.blog.v3.post',
      method: 'GET' as any,
      methodFqn:
        'com.wixpress.npm.communities.platformized.blog.BlogStatsService.QueryPostCountStats',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressNpmCommunitiesPlatformizedBlogBlogStatsServiceUrl({
        protoPath: '/v2/stats/post/count',
        data: serializedData,
        host,
      }),
      params: toURLSearchParams(serializedData),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [{ path: 'stats.periodStart' }],
          },
        ]),
    };

    return metadata;
  }

  return __queryPostCountStats;
}

/** Retrieves the total amount of published posts of the blog. */
export function getTotalPosts(payload: object): RequestOptionsFactory<any> {
  function __getTotalPosts({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.blog.v3.post',
      method: 'GET' as any,
      methodFqn:
        'com.wixpress.npm.communities.platformized.blog.BlogStatsService.GetTotalPosts',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressNpmCommunitiesPlatformizedBlogBlogStatsServiceUrl({
        protoPath: '/v2/stats/posts/total',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __getTotalPosts;
}

/** Retrieves a post by the specified ID. */
export function getPost(payload: object): RequestOptionsFactory<any> {
  function __getPost({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.blog.v3.post',
      method: 'GET' as any,
      methodFqn:
        'com.wixpress.npm.communities.platformized.blog.v3.PostService.GetPost',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3PostServiceUrl({
        protoPath: '/v3/posts/{postId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'post.firstPublishedDate' },
              { path: 'post.lastPublishedDate' },
              { path: 'post.heroImage.urlExpirationDate' },
              { path: 'post.richContent.metadata.createdTimestamp' },
              { path: 'post.richContent.metadata.updatedTimestamp' },
              { path: 'post.moderationDetails.submittedDate' },
              { path: 'post.moderationDetails.moderationDate' },
              { path: 'post.media.wixMedia.image.urlExpirationDate' },
              { path: 'post.media.wixMedia.videoV2.urlExpirationDate' },
              {
                path: 'post.media.wixMedia.videoV2.resolutions.urlExpirationDate',
              },
              {
                path: 'post.media.wixMedia.videoV2.resolutions.poster.urlExpirationDate',
              },
              { path: 'post.media.wixMedia.videoV2.posters.urlExpirationDate' },
            ],
          },
          {
            transformFn: transformRESTBytesToSDKBytes,
            paths: [{ path: 'post.richContentCompressed' }],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'post.heroImage.focalPoint.x' },
              { path: 'post.heroImage.focalPoint.y' },
              { path: 'post.media.wixMedia.image.focalPoint.x' },
              { path: 'post.media.wixMedia.image.focalPoint.y' },
              {
                path: 'post.media.wixMedia.videoV2.resolutions.poster.focalPoint.x',
              },
              {
                path: 'post.media.wixMedia.videoV2.resolutions.poster.focalPoint.y',
              },
              { path: 'post.media.wixMedia.videoV2.posters.focalPoint.x' },
              { path: 'post.media.wixMedia.videoV2.posters.focalPoint.y' },
              { path: 'post.metrics.averageRating' },
              {
                path: 'post.richContent.nodes.buttonData.styles.background.gradient.centerX',
              },
              {
                path: 'post.richContent.nodes.buttonData.styles.background.gradient.centerY',
              },
              {
                path: 'post.richContent.nodes.buttonData.styles.background.gradient.stops.position',
              },
              {
                path: 'post.richContent.nodes.buttonData.styles.backgroundHover.gradient.centerX',
              },
              {
                path: 'post.richContent.nodes.buttonData.styles.backgroundHover.gradient.centerY',
              },
              {
                path: 'post.richContent.nodes.buttonData.styles.backgroundHover.gradient.stops.position',
              },
              {
                path: 'post.richContent.nodes.galleryData.items.image.media.duration',
              },
              {
                path: 'post.richContent.nodes.galleryData.items.video.media.duration',
              },
              {
                path: 'post.richContent.nodes.galleryData.items.video.thumbnail.duration',
              },
              { path: 'post.richContent.nodes.galleryData.options.item.ratio' },
              { path: 'post.richContent.nodes.imageData.image.duration' },
              { path: 'post.richContent.nodes.mapData.mapSettings.lat' },
              { path: 'post.richContent.nodes.mapData.mapSettings.lng' },
              { path: 'post.richContent.nodes.pollData.poll.image.duration' },
              {
                path: 'post.richContent.nodes.pollData.poll.options.image.duration',
              },
              {
                path: 'post.richContent.nodes.pollData.design.poll.background.image.duration',
              },
              { path: 'post.richContent.nodes.appEmbedData.image.duration' },
              { path: 'post.richContent.nodes.videoData.video.duration' },
              { path: 'post.richContent.nodes.videoData.thumbnail.duration' },
              { path: 'post.richContent.nodes.audioData.audio.duration' },
              { path: 'post.richContent.nodes.audioData.coverImage.duration' },
              {
                path: 'post.richContent.nodes.layoutData.backgroundImage.media.duration',
              },
              {
                path: 'post.richContent.nodes.layoutData.backdropImage.media.duration',
              },
              {
                path: 'post.richContent.nodes.layoutData.background.gradient.centerX',
              },
              {
                path: 'post.richContent.nodes.layoutData.background.gradient.centerY',
              },
              {
                path: 'post.richContent.nodes.layoutData.background.gradient.stops.position',
              },
              {
                path: 'post.richContent.nodes.layoutData.backdrop.gradient.centerX',
              },
              {
                path: 'post.richContent.nodes.layoutData.backdrop.gradient.centerY',
              },
              {
                path: 'post.richContent.nodes.layoutData.backdrop.gradient.stops.position',
              },
              { path: 'post.richContent.nodes.shapeData.shape.duration' },
              {
                path: 'post.richContent.nodes.cardData.background.gradient.centerX',
              },
              {
                path: 'post.richContent.nodes.cardData.background.gradient.centerY',
              },
              {
                path: 'post.richContent.nodes.cardData.background.gradient.stops.position',
              },
              {
                path: 'post.richContent.nodes.cardData.backgroundImage.media.duration',
              },
              { path: 'post.richContent.nodes.tocData.fontSize' },
              { path: 'post.richContent.nodes.tocData.itemSpacing' },
              {
                path: 'post.richContent.nodes.smartBlockCellData.shape.duration',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __getPost;
}

/**
 * Retrieves a post with the provided slug.
 *
 * The slug is the end of a post's URL that refers to a specific post.
 * For example, if a post's URL is `https:/example.com/blog/post/my-post-slug`,
 * the slug is `my-post-slug`. The slug is case-sensitive, and is generally derived from the post title,
 * unless specified otherwise.
 */
export function getPostBySlug(payload: object): RequestOptionsFactory<any> {
  function __getPostBySlug({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.blog.v3.post',
      method: 'GET' as any,
      methodFqn:
        'com.wixpress.npm.communities.platformized.blog.v3.PostService.GetPostBySlug',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3PostServiceUrl({
        protoPath: '/v3/posts/slugs/{slug}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'post.firstPublishedDate' },
              { path: 'post.lastPublishedDate' },
              { path: 'post.heroImage.urlExpirationDate' },
              { path: 'post.richContent.metadata.createdTimestamp' },
              { path: 'post.richContent.metadata.updatedTimestamp' },
              { path: 'post.moderationDetails.submittedDate' },
              { path: 'post.moderationDetails.moderationDate' },
              { path: 'post.media.wixMedia.image.urlExpirationDate' },
              { path: 'post.media.wixMedia.videoV2.urlExpirationDate' },
              {
                path: 'post.media.wixMedia.videoV2.resolutions.urlExpirationDate',
              },
              {
                path: 'post.media.wixMedia.videoV2.resolutions.poster.urlExpirationDate',
              },
              { path: 'post.media.wixMedia.videoV2.posters.urlExpirationDate' },
            ],
          },
          {
            transformFn: transformRESTBytesToSDKBytes,
            paths: [{ path: 'post.richContentCompressed' }],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'post.heroImage.focalPoint.x' },
              { path: 'post.heroImage.focalPoint.y' },
              { path: 'post.media.wixMedia.image.focalPoint.x' },
              { path: 'post.media.wixMedia.image.focalPoint.y' },
              {
                path: 'post.media.wixMedia.videoV2.resolutions.poster.focalPoint.x',
              },
              {
                path: 'post.media.wixMedia.videoV2.resolutions.poster.focalPoint.y',
              },
              { path: 'post.media.wixMedia.videoV2.posters.focalPoint.x' },
              { path: 'post.media.wixMedia.videoV2.posters.focalPoint.y' },
              { path: 'post.metrics.averageRating' },
              {
                path: 'post.richContent.nodes.buttonData.styles.background.gradient.centerX',
              },
              {
                path: 'post.richContent.nodes.buttonData.styles.background.gradient.centerY',
              },
              {
                path: 'post.richContent.nodes.buttonData.styles.background.gradient.stops.position',
              },
              {
                path: 'post.richContent.nodes.buttonData.styles.backgroundHover.gradient.centerX',
              },
              {
                path: 'post.richContent.nodes.buttonData.styles.backgroundHover.gradient.centerY',
              },
              {
                path: 'post.richContent.nodes.buttonData.styles.backgroundHover.gradient.stops.position',
              },
              {
                path: 'post.richContent.nodes.galleryData.items.image.media.duration',
              },
              {
                path: 'post.richContent.nodes.galleryData.items.video.media.duration',
              },
              {
                path: 'post.richContent.nodes.galleryData.items.video.thumbnail.duration',
              },
              { path: 'post.richContent.nodes.galleryData.options.item.ratio' },
              { path: 'post.richContent.nodes.imageData.image.duration' },
              { path: 'post.richContent.nodes.mapData.mapSettings.lat' },
              { path: 'post.richContent.nodes.mapData.mapSettings.lng' },
              { path: 'post.richContent.nodes.pollData.poll.image.duration' },
              {
                path: 'post.richContent.nodes.pollData.poll.options.image.duration',
              },
              {
                path: 'post.richContent.nodes.pollData.design.poll.background.image.duration',
              },
              { path: 'post.richContent.nodes.appEmbedData.image.duration' },
              { path: 'post.richContent.nodes.videoData.video.duration' },
              { path: 'post.richContent.nodes.videoData.thumbnail.duration' },
              { path: 'post.richContent.nodes.audioData.audio.duration' },
              { path: 'post.richContent.nodes.audioData.coverImage.duration' },
              {
                path: 'post.richContent.nodes.layoutData.backgroundImage.media.duration',
              },
              {
                path: 'post.richContent.nodes.layoutData.backdropImage.media.duration',
              },
              {
                path: 'post.richContent.nodes.layoutData.background.gradient.centerX',
              },
              {
                path: 'post.richContent.nodes.layoutData.background.gradient.centerY',
              },
              {
                path: 'post.richContent.nodes.layoutData.background.gradient.stops.position',
              },
              {
                path: 'post.richContent.nodes.layoutData.backdrop.gradient.centerX',
              },
              {
                path: 'post.richContent.nodes.layoutData.backdrop.gradient.centerY',
              },
              {
                path: 'post.richContent.nodes.layoutData.backdrop.gradient.stops.position',
              },
              { path: 'post.richContent.nodes.shapeData.shape.duration' },
              {
                path: 'post.richContent.nodes.cardData.background.gradient.centerX',
              },
              {
                path: 'post.richContent.nodes.cardData.background.gradient.centerY',
              },
              {
                path: 'post.richContent.nodes.cardData.background.gradient.stops.position',
              },
              {
                path: 'post.richContent.nodes.cardData.backgroundImage.media.duration',
              },
              { path: 'post.richContent.nodes.tocData.fontSize' },
              { path: 'post.richContent.nodes.tocData.itemSpacing' },
              {
                path: 'post.richContent.nodes.smartBlockCellData.shape.duration',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __getPostBySlug;
}

/**
 * Retrieves a list of up to 100 published posts per request.
 *
 * List Posts runs with these defaults, which you can override:
 * - `firstPublishedDate` is sorted in descending order, with pinned posts first.
 * - `paging.limit` is `50`.
 * - `paging.offset` is `0`.
 */
export function listPosts(payload: object): RequestOptionsFactory<any> {
  function __listPosts({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.blog.v3.post',
      method: 'GET' as any,
      methodFqn:
        'com.wixpress.npm.communities.platformized.blog.v3.PostService.ListPosts',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3PostServiceUrl({
        protoPath: '/v3/posts',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'posts.firstPublishedDate' },
              { path: 'posts.lastPublishedDate' },
              { path: 'posts.heroImage.urlExpirationDate' },
              { path: 'posts.richContent.metadata.createdTimestamp' },
              { path: 'posts.richContent.metadata.updatedTimestamp' },
              { path: 'posts.moderationDetails.submittedDate' },
              { path: 'posts.moderationDetails.moderationDate' },
              { path: 'posts.media.wixMedia.image.urlExpirationDate' },
              { path: 'posts.media.wixMedia.videoV2.urlExpirationDate' },
              {
                path: 'posts.media.wixMedia.videoV2.resolutions.urlExpirationDate',
              },
              {
                path: 'posts.media.wixMedia.videoV2.resolutions.poster.urlExpirationDate',
              },
              {
                path: 'posts.media.wixMedia.videoV2.posters.urlExpirationDate',
              },
            ],
          },
          {
            transformFn: transformRESTBytesToSDKBytes,
            paths: [{ path: 'posts.richContentCompressed' }],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'posts.heroImage.focalPoint.x' },
              { path: 'posts.heroImage.focalPoint.y' },
              { path: 'posts.media.wixMedia.image.focalPoint.x' },
              { path: 'posts.media.wixMedia.image.focalPoint.y' },
              {
                path: 'posts.media.wixMedia.videoV2.resolutions.poster.focalPoint.x',
              },
              {
                path: 'posts.media.wixMedia.videoV2.resolutions.poster.focalPoint.y',
              },
              { path: 'posts.media.wixMedia.videoV2.posters.focalPoint.x' },
              { path: 'posts.media.wixMedia.videoV2.posters.focalPoint.y' },
              { path: 'posts.metrics.averageRating' },
              {
                path: 'posts.richContent.nodes.buttonData.styles.background.gradient.centerX',
              },
              {
                path: 'posts.richContent.nodes.buttonData.styles.background.gradient.centerY',
              },
              {
                path: 'posts.richContent.nodes.buttonData.styles.background.gradient.stops.position',
              },
              {
                path: 'posts.richContent.nodes.buttonData.styles.backgroundHover.gradient.centerX',
              },
              {
                path: 'posts.richContent.nodes.buttonData.styles.backgroundHover.gradient.centerY',
              },
              {
                path: 'posts.richContent.nodes.buttonData.styles.backgroundHover.gradient.stops.position',
              },
              {
                path: 'posts.richContent.nodes.galleryData.items.image.media.duration',
              },
              {
                path: 'posts.richContent.nodes.galleryData.items.video.media.duration',
              },
              {
                path: 'posts.richContent.nodes.galleryData.items.video.thumbnail.duration',
              },
              {
                path: 'posts.richContent.nodes.galleryData.options.item.ratio',
              },
              { path: 'posts.richContent.nodes.imageData.image.duration' },
              { path: 'posts.richContent.nodes.mapData.mapSettings.lat' },
              { path: 'posts.richContent.nodes.mapData.mapSettings.lng' },
              { path: 'posts.richContent.nodes.pollData.poll.image.duration' },
              {
                path: 'posts.richContent.nodes.pollData.poll.options.image.duration',
              },
              {
                path: 'posts.richContent.nodes.pollData.design.poll.background.image.duration',
              },
              { path: 'posts.richContent.nodes.appEmbedData.image.duration' },
              { path: 'posts.richContent.nodes.videoData.video.duration' },
              { path: 'posts.richContent.nodes.videoData.thumbnail.duration' },
              { path: 'posts.richContent.nodes.audioData.audio.duration' },
              { path: 'posts.richContent.nodes.audioData.coverImage.duration' },
              {
                path: 'posts.richContent.nodes.layoutData.backgroundImage.media.duration',
              },
              {
                path: 'posts.richContent.nodes.layoutData.backdropImage.media.duration',
              },
              {
                path: 'posts.richContent.nodes.layoutData.background.gradient.centerX',
              },
              {
                path: 'posts.richContent.nodes.layoutData.background.gradient.centerY',
              },
              {
                path: 'posts.richContent.nodes.layoutData.background.gradient.stops.position',
              },
              {
                path: 'posts.richContent.nodes.layoutData.backdrop.gradient.centerX',
              },
              {
                path: 'posts.richContent.nodes.layoutData.backdrop.gradient.centerY',
              },
              {
                path: 'posts.richContent.nodes.layoutData.backdrop.gradient.stops.position',
              },
              { path: 'posts.richContent.nodes.shapeData.shape.duration' },
              {
                path: 'posts.richContent.nodes.cardData.background.gradient.centerX',
              },
              {
                path: 'posts.richContent.nodes.cardData.background.gradient.centerY',
              },
              {
                path: 'posts.richContent.nodes.cardData.background.gradient.stops.position',
              },
              {
                path: 'posts.richContent.nodes.cardData.backgroundImage.media.duration',
              },
              { path: 'posts.richContent.nodes.tocData.fontSize' },
              { path: 'posts.richContent.nodes.tocData.itemSpacing' },
              {
                path: 'posts.richContent.nodes.smartBlockCellData.shape.duration',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __listPosts;
}

/**
 * Retrieves a list of up to 100 posts, given the provided paging, filtering, and sorting.
 *
 * Query Posts runs with these defaults, which you can override:
 * - `firstPublishedDate` is sorted in descending order, with pinned posts first.
 * - `paging.limit` is `50`.
 * - `paging.offset` is `0`.
 *
 * To learn about working with _Query_ endpoints, see
 * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language),
 * [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/sorting-and-paging), and
 * [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 */
export function queryPosts(payload: object): RequestOptionsFactory<any> {
  function __queryPosts({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.blog.v3.post',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.npm.communities.platformized.blog.v3.PostService.QueryPosts',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3PostServiceUrl({
        protoPath: '/v3/posts/query',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'posts.firstPublishedDate' },
              { path: 'posts.lastPublishedDate' },
              { path: 'posts.heroImage.urlExpirationDate' },
              { path: 'posts.richContent.metadata.createdTimestamp' },
              { path: 'posts.richContent.metadata.updatedTimestamp' },
              { path: 'posts.moderationDetails.submittedDate' },
              { path: 'posts.moderationDetails.moderationDate' },
              { path: 'posts.media.wixMedia.image.urlExpirationDate' },
              { path: 'posts.media.wixMedia.videoV2.urlExpirationDate' },
              {
                path: 'posts.media.wixMedia.videoV2.resolutions.urlExpirationDate',
              },
              {
                path: 'posts.media.wixMedia.videoV2.resolutions.poster.urlExpirationDate',
              },
              {
                path: 'posts.media.wixMedia.videoV2.posters.urlExpirationDate',
              },
            ],
          },
          {
            transformFn: transformRESTBytesToSDKBytes,
            paths: [{ path: 'posts.richContentCompressed' }],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'posts.heroImage.focalPoint.x' },
              { path: 'posts.heroImage.focalPoint.y' },
              { path: 'posts.media.wixMedia.image.focalPoint.x' },
              { path: 'posts.media.wixMedia.image.focalPoint.y' },
              {
                path: 'posts.media.wixMedia.videoV2.resolutions.poster.focalPoint.x',
              },
              {
                path: 'posts.media.wixMedia.videoV2.resolutions.poster.focalPoint.y',
              },
              { path: 'posts.media.wixMedia.videoV2.posters.focalPoint.x' },
              { path: 'posts.media.wixMedia.videoV2.posters.focalPoint.y' },
              { path: 'posts.metrics.averageRating' },
              {
                path: 'posts.richContent.nodes.buttonData.styles.background.gradient.centerX',
              },
              {
                path: 'posts.richContent.nodes.buttonData.styles.background.gradient.centerY',
              },
              {
                path: 'posts.richContent.nodes.buttonData.styles.background.gradient.stops.position',
              },
              {
                path: 'posts.richContent.nodes.buttonData.styles.backgroundHover.gradient.centerX',
              },
              {
                path: 'posts.richContent.nodes.buttonData.styles.backgroundHover.gradient.centerY',
              },
              {
                path: 'posts.richContent.nodes.buttonData.styles.backgroundHover.gradient.stops.position',
              },
              {
                path: 'posts.richContent.nodes.galleryData.items.image.media.duration',
              },
              {
                path: 'posts.richContent.nodes.galleryData.items.video.media.duration',
              },
              {
                path: 'posts.richContent.nodes.galleryData.items.video.thumbnail.duration',
              },
              {
                path: 'posts.richContent.nodes.galleryData.options.item.ratio',
              },
              { path: 'posts.richContent.nodes.imageData.image.duration' },
              { path: 'posts.richContent.nodes.mapData.mapSettings.lat' },
              { path: 'posts.richContent.nodes.mapData.mapSettings.lng' },
              { path: 'posts.richContent.nodes.pollData.poll.image.duration' },
              {
                path: 'posts.richContent.nodes.pollData.poll.options.image.duration',
              },
              {
                path: 'posts.richContent.nodes.pollData.design.poll.background.image.duration',
              },
              { path: 'posts.richContent.nodes.appEmbedData.image.duration' },
              { path: 'posts.richContent.nodes.videoData.video.duration' },
              { path: 'posts.richContent.nodes.videoData.thumbnail.duration' },
              { path: 'posts.richContent.nodes.audioData.audio.duration' },
              { path: 'posts.richContent.nodes.audioData.coverImage.duration' },
              {
                path: 'posts.richContent.nodes.layoutData.backgroundImage.media.duration',
              },
              {
                path: 'posts.richContent.nodes.layoutData.backdropImage.media.duration',
              },
              {
                path: 'posts.richContent.nodes.layoutData.background.gradient.centerX',
              },
              {
                path: 'posts.richContent.nodes.layoutData.background.gradient.centerY',
              },
              {
                path: 'posts.richContent.nodes.layoutData.background.gradient.stops.position',
              },
              {
                path: 'posts.richContent.nodes.layoutData.backdrop.gradient.centerX',
              },
              {
                path: 'posts.richContent.nodes.layoutData.backdrop.gradient.centerY',
              },
              {
                path: 'posts.richContent.nodes.layoutData.backdrop.gradient.stops.position',
              },
              { path: 'posts.richContent.nodes.shapeData.shape.duration' },
              {
                path: 'posts.richContent.nodes.cardData.background.gradient.centerX',
              },
              {
                path: 'posts.richContent.nodes.cardData.background.gradient.centerY',
              },
              {
                path: 'posts.richContent.nodes.cardData.background.gradient.stops.position',
              },
              {
                path: 'posts.richContent.nodes.cardData.backgroundImage.media.duration',
              },
              { path: 'posts.richContent.nodes.tocData.fontSize' },
              { path: 'posts.richContent.nodes.tocData.itemSpacing' },
              {
                path: 'posts.richContent.nodes.smartBlockCellData.shape.duration',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __queryPosts;
}

/**
 * Retrieves a post's metrics.
 *
 * A post's metrics include the comments, likes, and views the post receives.
 */
export function getPostMetrics(payload: object): RequestOptionsFactory<any> {
  function __getPostMetrics({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.blog.v3.post',
      method: 'GET' as any,
      methodFqn:
        'com.wixpress.npm.communities.platformized.blog.v3.PostService.GetPostMetrics',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3PostServiceUrl({
        protoPath: '/v3/posts/{postId}/metrics',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [{ path: 'metrics.averageRating' }],
          },
        ]),
    };

    return metadata;
  }

  return __getPostMetrics;
}
